// extracted by mini-css-extract-plugin
export default {"formContainer":"note_input-module___formContainer___c9d28f68","input":"note_input-module___input___cbe18885"};